export const DEFAULT_LABELS = {
	accountPrimaryContactName: 'Application Submitter Name',
	accountPrimaryContactEmail: 'Application Submitter Email'
};
